import { Dialog, RaisedButton } from 'material-ui';
import React from 'react';
import './styles.scss';

/**
 * 
 * @param {{
 *  open: boolean, 
 *  handleClose: () => void, 
 *  actions: any[], 
 *  handleConvert: (param: 'userToAdmin' | 'adminToUser') => void,
 * }} param0 
 * @returns 
 */
export default function ConvertCargoDialog({
    open, handleClose, actions,
}) {
    return (
        <Dialog
            open={open}
            actions={actions}
            onRequestClose={handleClose}
        >
            <div className='convert-dialog'>
                <span>
                    Cargo will be converted to as approved by admin 
                    (that might generate a duplicate, which can be handled on <a href='/cargoes/duplicates' target='_blank'>duplicate cargoes page</a>)
                </span>
            </div>
        </Dialog>
    );
}



// WEBPACK FOOTER //
// ./app/components/Cargoes/RealNames/ConvertCargoDialog.jsx